import { parseApiResponse, } from "./client-transport-discovery.js";
import { canonicalHttpsOrigin } from "./http-origin.js";
const DEFAULT_TIMEOUT_MS = 5_000;
const ONBOARDING_STATUS_PATH = "/api/auth/onboarding-status";
export async function probeHomeNodeClaimed(address, options = {}) {
    let origin;
    try {
        origin = normalizeNodeAddress(address);
    }
    catch {
        return { reachable: false };
    }
    const fetchImpl = options.fetch ?? globalThis.fetch.bind(globalThis);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), options.timeoutMs ?? DEFAULT_TIMEOUT_MS);
    let response;
    try {
        response = await fetchImpl(new Request(new URL(ONBOARDING_STATUS_PATH, origin), {
            method: "GET",
            signal: controller.signal,
        }));
    }
    catch {
        return { reachable: false };
    }
    finally {
        clearTimeout(timeout);
    }
    if (!response.ok)
        return { reachable: false };
    let body;
    try {
        body = await response.json();
    }
    catch {
        return { reachable: false };
    }
    try {
        const envelope = parseApiResponse(body);
        const data = envelope.data;
        const claimed = isRecord(data) && typeof data.claimed === "boolean" ? data.claimed : undefined;
        return { claimed, reachable: true };
    }
    catch {
        return { reachable: false };
    }
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
/**
 * Coerces a bare IPv4, `.local` hostname, host:port, or `http(s)://` URL into an exact
 * HTTPS origin (default port 443). Throws `TypeError` on anything else — the caller
 * translates that into `{ reachable: false }` rather than propagating it. Mirrors
 * `normalizeNodeAddress` in `./node-address-discovery.ts` exactly.
 */
function normalizeNodeAddress(rawAddress) {
    const trimmed = rawAddress.trim();
    if (trimmed.length === 0)
        throw new TypeError("Node address must not be empty");
    const hasScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//u.test(trimmed);
    let url;
    try {
        url = new URL(hasScheme ? trimmed : `https://${trimmed}`);
    }
    catch {
        throw new TypeError("Node address is not a valid host or URL");
    }
    if (hasScheme && url.protocol !== "https:" && url.protocol !== "http:") {
        throw new TypeError("Node address must use http or https");
    }
    if (url.username !== "" || url.password !== "" || url.hostname === "" ||
        (url.pathname !== "/" && url.pathname !== "") || url.search !== "" || url.hash !== "") {
        throw new TypeError("Node address must be a bare host, optionally with a port");
    }
    const candidate = url.port === "" ? `https://${url.hostname}` : `https://${url.hostname}:${url.port}`;
    return canonicalHttpsOrigin(candidate);
}
//# sourceMappingURL=onboarding-claimed-probe.js.map